<div class="p-3">
    <div class="text-center pt-4">
        <!-- <h2 class="text-center usacademy-title">DMC ACADEMY </h2> --> <!--aca-->
        <h2 class="text-center usacademy-title">DMC LAB </h2>
        <h5 class="text-center usacademy-subtitle">Training and Certificates</h5>
    </div>
    <div class="note-btn text-center pt-2 pb-3">
        <button class="btn btn-usblick" [ngStyle]="{'background-color':getClientsSettingAppBooking?.clients_setting_global?.color_main_1}"></button>
    </div>
    <div class="card card-outline-primary mb-1 align-content-end pt-1">
        <div class="card-block">
            <div class="row">
                <div class="col-md-2 col-sm-2 col-2 text-center">
                    <div class="box_number">
                        <h6 class="box-number-sup">22</h6>
                        <h6 class="box-number-inf">10</h6>
                    </div>
                </div>
                <div class="col-md-10  col-sm-10 col-10 p-0">
                    <div class="d-flex justify-content-start">

                        <span class="box-title">Lo Nuevo y lo que viene</span>
                    </div>
                    <div class="d-flex justify-content-start">
                        <p class="box-subtitle">Promociones, ofertas, últimas novedades Orlando</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="card card-outline-primary mb-1 align-content-end pt-1">
        <div class="card-block">
            <div class="row">
                <div class="col-md-2 col-sm-2 col-2 text-center">
                    <div class="box_number">
                        <h6 class="box-number-sup">22</h6>
                        <h6 class="box-number-inf">10</h6>
                    </div>
                </div>
                <div class="col-md-10  col-sm-10 col-10 p-0">
                    <div class="d-flex justify-content-start">
                        <span class="box-title">Lo Nuevo y lo que viene</span>
                    </div>
                    <div class="d-flex justify-content-start">
                        <p class="box-subtitle">Promociones, ofertas, últimas novedades Orlando</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="card card-outline-primary mb-1 align-content-end pt-1">
        <div class="card-block">
            <div class="row">
                <div class="col-md-2 col-sm-2 col-2 text-center">
                    <div class="box_number">
                        <h6 class="box-number-sup">22</h6>
                        <h6 class="box-number-inf">10</h6>
                    </div>
                </div>
                <div class="col-md-10  col-sm-10 col-10 p-0">
                    <div class="d-flex justify-content-start">
                        <span class="box-title">Lo Nuevo y lo que viene</span>
                    </div>
                    <div class="d-flex justify-content-start">
                        <p class="box-subtitle">Promociones, ofertas, últimas novedades Orlando</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="card card-outline-primary mb-1 align-content-end pt-1">
        <div class="card-block">
            <div class="row">
                <div class="col-md-2 col-sm-2 col-2 text-center">
                    <div class="box_number">
                        <h6 class="box-number-sup">22</h6>
                        <h6 class="box-number-inf">10</h6>
                    </div>
                </div>
                <div class="col-md-10  col-sm-10 col-10 p-0">
                    <div class="d-flex justify-content-start">
                        <span class="box-title">Lo Nuevo y lo que viene</span>
                    </div>
                    <div class="d-flex justify-content-start">
                        <p class="box-subtitle">Promociones, ofertas, últimas novedades Orlando</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="container pt-3 pb-3">
            <div class="row">
                <div class="col-lg-12">
                    <div class="text-center">
                        <button class="boton"  [ngStyle]="{'background-color':getClientsSettingAppBooking?.clients_setting_global?.color_main_1, 'border':getClientsSettingAppBooking?.clients_setting_global?.color_main_1}">
                            VER +
                        </button>
                    </div>
                </div>
            </div>
    </div>
</div>
